import { LayoutProps } from "@jsonforms/core";
import { JsonFormsDispatch, withJsonFormsLayoutProps } from "@jsonforms/react";

function HorizontalLayoutComponent({
  uischema,
  schema,
  path,
  visible,
  renderers,
  cells,
  enabled,
}: LayoutProps) {
  if (!visible) return null;

  const layout = uischema as { elements: any[] };

  return (
    <div className="flex gap-4">
      {layout.elements.map((element, index) => (
        <div key={index} className="flex-1">
          <JsonFormsDispatch
            uischema={element}
            schema={schema}
            path={path}
            renderers={renderers}
            cells={cells}
            enabled={enabled}
          />
        </div>
      ))}
    </div>
  );
}

export const HorizontalLayout = withJsonFormsLayoutProps(
  HorizontalLayoutComponent,
);
